import { CONSENT_PROMOTION_LAYER_POPUP } from '@/common/resources/const'

// full page popup
import PopupConsentPromotion from '@/views/popup/PopupConsentPromotion.vue'

import { onMounted, onUnmounted, shallowRef, ref } from 'vue'
import { EventBus } from '@/components/eventbus/EventBus'

export const useLayerPopupLoader = () => {
  const layerPopup = shallowRef(null)
  const isPopupOpen = ref(false)
  const payloads = ref({})

  /**
   * @param layerPopupName
   * @returns {unknown}
   */
  const getLayerPopup = (layerPopupName) => {
    switch (layerPopupName) {
      case CONSENT_PROMOTION_LAYER_POPUP:
        layerPopup.value = PopupConsentPromotion
        break
    }
    return layerPopup.value
  }

  /**
   * set layer popup
   * @param payload
   * @param name
   */
  const setPopup = (payload, name) => {
    const { isOpen = false, ...rest } = payload
    payloads.value = rest
    isPopupOpen.value = isOpen
    getLayerPopup(name)
  }

  onMounted(() => {
    EventBus.$on(CONSENT_PROMOTION_LAYER_POPUP, (payload = { isOpen: false }) =>
      setPopup(payload, CONSENT_PROMOTION_LAYER_POPUP),
    )
  })

  onUnmounted(() => {
    EventBus.$off(CONSENT_PROMOTION_LAYER_POPUP)
  })

  return {
    layerPopup,
    isPopupOpen,
    payloads,
    getLayerPopup,
  }
}
